<header class="rs-table-banner rs-table-banner-top">
  <div class="rs-flex-row rs-flex-middle rs-justify-right">
    <div class="rs-flex-column rs-flex-shrink-medium show-for-medium-up">
      <p>
        <button
          class="rs-link-action rs-link-action-download"
          (click)="downloadCsv()"
          data-cy="myBillOdbUsageExportAsCSVButton"
          data-tms-button-zone="mybill.detail.usage"
          data-tms-button-name="Export all usage data (CSV, 100ko)"
          [attr.data-tms-context]="documentReference"
          [attr.data-tms-message-info]="billingAccountNumber"
        >
          <span class="rs-link-action-label" aria-hidden="true">{{
            'bills.cover.usageLevel4.tableHeader.exportAsCSVLabel' | translate
          }}</span>
          <span class="rs-action-link-icon" title="Download"
            ><span class="show-for-sr">{{
              'bills.cover.usageLevel4.tableHeader.exportAsCSVLabel' | translate
            }}</span></span
          >
        </button>
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <div
        class="rs-action-menu rs-action-menu-left rs-right-small-only"
        data-action-menu
      >
        <button
          class="rs-action-menu-trigger rs-action-menu-trigger-big"
          type="button"
          id="ac-actionMenuBig-btn"
          data-cy="myBillOdbUsageColumnsButton"
          data-dropdown="ac-actionMenuBig"
          aria-controls="ac-actionMenuBig"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i
            class="icon-Points icon-lh"
            attr.aria-label="{{
              'bills.cover.usageLevel4.tableHeader.reorderColumns.title'
                | translate
            }}"
          ></i>
        </button>
        <div
          class="rs-action-menu-content"
          id="ac-actionMenuBig"
          aria-labelledby="ac-actionMenuBig-btn"
          data-dropdown-content
          aria-hidden="true"
          data-cy="myBillOdbUsageColumnsOverlay"
        >
          <ul class="rs-action-menu-list">
            <li class="rs-action-menu-item" aria-hidden="true">
              <div class="rs-action-menu-title">
                <button
                  class="rs-btn-no-style rs-txt-hover rs-txt-focus"
                  attr.aria-label="{{
                    'bills.cover.usageLevel4.tableHeader.reorderColumns.screenReader.openOverlayerToSeeHow'
                      | translate
                  }}"
                  data-reveal=""
                  data-reveal-id="dragDropInfoOverlayer"
                  type="button"
                  (click)="openReorderColumnsModal()"
                  data-cy="reorderColumnsButton"
                >
                  <span>{{
                    'bills.cover.usageLevel4.tableHeader.reorderColumns.title'
                      | translate
                  }}</span>
                  <i aria-hidden="true" class="icon-Information-box"></i>
                </button>
              </div>
              <div
                class="rs-draggable"
                data-draggable
                data-rslib-webcomponent-load="rslib.apps.draggable"
              >
                <ol
                  class="rs-draggable-list"
                  role="list"
                  aria-dropeffect="move"
                  data-draggable-list
                  libDragAndDrop
                  (dropped)="handleReorder($event)"
                >
                  <li
                    class="rs-draggable-item"
                    libDraggableItem
                    dragId="datetime"
                    role="listitem"
                    draggable="true"
                    tabindex="0"
                    aria-grabbed="false"
                    aria-haspopup="true"
                    data-cy="myBillOdbUsageColumnsOverlayItem-datetime"
                  >
                    <span class="rs-draggable-form">
                      <div class="rs-form-item">
                        <div class="rs-checkbox">
                          <input
                            type="checkbox"
                            name="check1"
                            id="ac-check1"
                            [(ngModel)]="checkboxes.datetime"
                            (ngModelChange)="handleCheckboxChange()"
                            data-cy="myBillOdbUsageColumnsOverlayItemCheckbox-datetime"
                          />
                          <label
                            for="ac-check1"
                            data-cy="myBillOdbUsageColumnsOverlayItemLabel-datetime"
                            >{{
                              'bills.cover.usageLevel4.tableHeader.dateAndTime'
                                | translate
                            }}</label
                          >
                        </div>
                      </div>
                    </span>
                    <span
                      class="rs-draggable-icon"
                      attr.aria-label="{{
                        'bills.cover.usageLevel4.tableHeader.reorderColumns.screenReader.draggable'
                          | translate
                      }}"
                    ></span>
                  </li>
                  <li
                    class="rs-draggable-item"
                    libDraggableItem
                    dragId="destination"
                    role="listitem"
                    draggable="true"
                    tabindex="0"
                    aria-grabbed="false"
                    aria-haspopup="true"
                    data-cy="myBillOdbUsageColumnsOverlayItem-destination"
                    *ngIf="shouldShowDestinationColumn"
                  >
                    <span class="rs-draggable-form">
                      <div class="rs-form-item">
                        <div class="rs-checkbox">
                          <input
                            type="checkbox"
                            name="check3"
                            id="ac-check3"
                            [(ngModel)]="checkboxes.destination"
                            (ngModelChange)="handleCheckboxChange()"
                            data-cy="myBillOdbUsageColumnsOverlayItemCheckbox-destination"
                          />
                          <label
                            for="ac-check3"
                            data-cy="myBillOdbUsageColumnsOverlayItemLabel-destination"
                            >{{
                              'bills.cover.usageLevel4.tableHeader.destination'
                                | translate
                            }}</label
                          >
                        </div>
                      </div>
                    </span>
                    <span
                      class="rs-draggable-icon"
                      attr.aria-label="{{
                        'bills.cover.usageLevel4.tableHeader.reorderColumns.screenReader.draggable'
                          | translate
                      }}"
                    ></span>
                  </li>
                  <li
                    class="rs-draggable-item"
                    libDraggableItem
                    dragId="durationOrVolume"
                    role="listitem"
                    draggable="true"
                    tabindex="0"
                    aria-grabbed="false"
                    aria-haspopup="true"
                    data-cy="myBillOdbUsageColumnsOverlayItem-durationOrVolume"
                    *ngIf="shouldShowDurationColumn"
                  >
                    <span class="rs-draggable-form">
                      <div class="rs-form-item">
                        <div class="rs-checkbox">
                          <input
                            type="checkbox"
                            name="check4"
                            id="ac-check4"
                            [(ngModel)]="checkboxes.durationOrVolume"
                            (ngModelChange)="handleCheckboxChange()"
                            data-cy="myBillOdbUsageColumnsOverlayItemCheckbox-durationOrVolume"
                          />
                          <label
                            for="ac-check4"
                            data-cy="myBillOdbUsageColumnsOverlayItemLabel-durationOrVolume"
                            *ngIf="hasDurationTypeInSec"
                            >{{
                              'bills.cover.usageLevel4.tableHeader.duration'
                                | translate
                            }}</label
                          >
                          <label
                            for="ac-check4"
                            *ngIf="!hasDurationTypeInSec"
                            data-cy="myBillOdbUsageColumnsOverlayItemLabel-durationOrVolume"
                            >{{
                              'bills.cover.usageLevel4.tableHeader.volume'
                                | translate
                            }}</label
                          >
                        </div>
                      </div>
                    </span>
                    <span
                      class="rs-draggable-icon"
                      attr.aria-label="{{
                        'bills.cover.usageLevel4.tableHeader.reorderColumns.screenReader.draggable'
                          | translate
                      }}"
                    ></span>
                  </li>
                  <li
                    class="rs-draggable-item rs-disabled"
                    libDraggableItem
                    itemDisabled="true"
                    dragId="price"
                    draggable="false"
                    role="listitem"
                    data-cy="myBillOdbUsageColumnsOverlayItem-price"
                  >
                    <span class="rs-draggable-form">
                      <div class="rs-form-item">
                        <div class="rs-checkbox">
                          <input
                            type="checkbox"
                            name="check5"
                            id="ac-check5"
                            disabled
                            checked
                            data-cy="myBillOdbUsageColumnsOverlayItemCheckbox-price"
                          />
                          <label
                            for="ac-check5"
                            data-cy="myBillOdbUsageColumnsOverlayItemLabel-price"
                            >{{
                              'bills.cover.usageLevel4.tableHeader.price'
                                | translate
                            }}</label
                          >
                        </div>
                      </div>
                    </span>
                    <span
                      class="rs-draggable-icon"
                      attr.aria-label="{{
                        'bills.cover.usageLevel4.tableHeader.reorderColumns.screenReader.notDraggable'
                          | translate
                      }}"
                    ></span>
                  </li>
                </ol>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>
<my-bill-odb-usage-level-four-table-header-reorder-columns-modal
  [showModal]="showReorderColumnsModal"
  (hideModal)="onHideReorderColumnsModal()"
></my-bill-odb-usage-level-four-table-header-reorder-columns-modal>
